<template>
    <div v-redirect-if-no-permission:CASH_REGISTER>
        <loading :value="loading" message="Searching"></loading>
        <v-card>
            <v-card-title>
                <b>Cash Registers</b>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        @keyup.enter="getData"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog = true" v-if="hasPermission('CASH_REGISTER_MASTER')">New</v-btn>
            </v-card-title>
            <v-data-table :loading="loading" :headers="headers" :items="data" class="elevation-1">
                <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.id }}</td>
                    <td class="text-xs-center">{{ props.item.name }}</td>
                    <td class="text-xs-center">{{ props.item.balance }}</td>
                    <td class="text-xs-center">{{ props.item.created_at }}</td>
                    <td class="text-xs-center">
                        <v-btn @click="$router.push(`/accounting/cash_register/${props.item.id}`)" icon>
                            <v-icon>info</v-icon>
                        </v-btn>
                        <v-btn @click="$router.push(`/accounting/cash_register/${props.item.id}`)" icon>
                            <v-icon color="red">fa-trash</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" width="500px">
            <v-card>
                <v-card-title><b>New Cash Register</b></v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid">
                        <v-text-field :rules="requiredRules" v-model="model.name" label="Name"></v-text-field>
                        <choose-user-multi v-model="model.user_id" :rules="requiredRules"></choose-user-multi>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="create">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import loading from "@/components/LoadingComponent";
    import ChooseUserMulti from "@/components/wasilni/input/ChooseUserMutli";

    export default {
        name: "Cash_Register",
        components: {ChooseUserMulti, loading},
        data() {
            return {
                requiredRules: [
                    v => v !== null && v !== undefined && v !== '' || 'This Field Is Required',
                ],
                model: {name: ''},
                headers: [
                    {text: '#', value: 'id', align: 'center'},
                    {text: 'Name', value: 'name', align: 'center'},
                    {text: 'Balance', value: 'balance', align: 'center'},
                    {text: 'Created At', value: 'created_at', align: 'center'},
                    {text: 'Actions', value: 'actions', align: 'center'}
                ],
                data: [],
                search: '',
                loading: false,
                dialog: false,
                valid: false,
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.loading = true;
                this.axios.get(`cash_registers?search=${this.search}`)
                    .then(res => this.data = Array.isArray(res.data.data) ? res.data.data : Object.values(res.data.data))
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            create() {
                if (!this.$refs.form.validate()) {
                    return;
                }
                this.loading = true;
                this.axios.post('cash_registers', this.model)
                    .then(res => {
                        this.data.push(res.data.data)
                        this.dialog = false;
                        this.model = {};
                        this.$refs.form.reset();
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>